import {
  destroyAdmin,
  getAdmin,
  postAdminForm,
  putAdminForm,
} from "../axios/api/AdminBaseUrl";
import { buildQueryString } from "../utils/queryParams";

export const company = {
  list:{
  key:"list",
  call: (page, search, statusFilter, ordering) => {
    const query = buildQueryString({ page, search, status: statusFilter, ordering })
    return getAdmin(`/admin/company/?${query}`)
  }
},
  details: {
    key: "details",
    call: (id) => {
      return getAdmin(`/admin/company/${id}/`);
    },
  },
  delete: {
    key: "delete",
    call: (id, permanent = false) => {
      const query = permanent ? "?permanent=true" : "";
      return destroyAdmin(`/admin/company/${id}/${query}`);
    },
  },
  add: {
    key: "add",
    call: (payload) => {
      return postAdminForm(`/admin/company/`, payload);
    },
  },
  update: {
    key: "update",
    call: (Id, payload) => {
      return putAdminForm(`/admin/company/${Id}/`, payload);
    },
  },
  excel: {
    key: "excel",
    call: (company_id, payload) => {
      return postAdminForm(
        `/admin/property-manager-upload/${company_id}/`,
        payload,
      );
    },
  },
  companyExcel: {
    key: "companyExcel",
    call: (payload) => {
      return postAdminForm("/admin/company-excel-upload/", payload);
    },
  },
  companybasedpropertymanagerlist: {
    key: "companybasedpropertymanagerlist",
    call: (companyId, page, search, statusFilter) => {
      const query = buildQueryString({
        page,
        search,
        status: statusFilter,
      });
      return getAdmin(`/admin/property-managers/${companyId}/?${query}`);
    },
  },
};
